module.exports = __webpack_public_path__ + "static/MH-656c7fa10c5a4ebf149bc72d6012fe42.jpg";